import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({

  //Common
  button: {
    borderRadius: 60,
    border: "2px solid transparent",
    display: "inline-block",
    textAlign: "center",
    fontSize: 15,
    fontWeight: 600,
    color: "#FFFFFF",
    textDecoration: "none",
    paddingLeft: 24,
    paddingRight: 24,
    fontFamily: "Montserrat, Sans Serif, Ubuntu, Droid Sans, Roboto, San Francisco",
    cursor: "pointer",
    "&[disabled]": {
      cursor: "default"
    },
    "&:hover, &:focus": {
      textDecoration: "none"
    }
  },
  outlined: {
    border: "2px solid"
  },

  //Primary
  primary: {
    backgroundColor: "#65C15D",
    "&$outlined": {
      borderColor: "#65C15D",
      backgroundColor: "transparent",
      color: "#65C15D",
      "&:hover, &:focus": {
        backgroundColor: "#65C15D",
        color: "#FFFFFF"
      }
    },
    "&:hover, &:focus": {
      backgroundColor: "#97DE6B",
      color: "#FFFFFF"
    },
    "&[disabled]": {
      backgroundColor: "#D4EBD2",
      "&$outlined": {
        color: "#AEDCAA",
        borderColor: "#AEDCAA",
        backgroundColor: "transparent",
        "&:hover, &:focus": {
          color: "#AEDCAA",
          backgroundColor: "transparent"
        }
      }
    },
  },

  //Secondary
  secondary: {
    backgroundColor: "#6049EB",
    "&$outlined": {
      borderColor: "#FFFFFF",
      backgroundColor: "transparent",
      color: "#FFFFFF",
      "&:hover, &:focus": {
        backgroundColor: "#7770FF",
        borderColor: "#7770FF",
        // boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.08), 0px 16px 16px rgba(0, 0, 0, 0.08)"
      }
    },
    "&:hover, &:focus": {
      backgroundColor: "#7770FF",
      color: "#FFFFFF"
    },
    "&[disabled]": {
      backgroundColor: "#D3CDF5",
      "&$outlined": {
        color: "#B0A4F5",
        borderColor: "#B0A4F5",
        backgroundColor: "transparent",
        "&:hover, &:focus": {
          color: "#B0A4F5",
          backgroundColor: "transparent",
          boxShadow: "none"
        }
      }
    }
  },
  //Tertiary
  tertiary: {
    "&$outlined": {
      borderColor: "#CBCEDA",
      backgroundColor: "transparent",
      color: "#2D2442",
      "&:hover": {
        backgroundColor: "#CBCEDA",
        borderColor: "#CBCEDA",
      }
    },
    "&[disabled]": {
      "&$outlined": {
        opacity: 0.5,
        color: "#2D2442",
        borderColor: "#CBCEDA",
        backgroundColor: "transparent",
        "&:hover, &:focus": {
          color: "#2D2442",
          backgroundColor: "transparent",
          boxShadow: "none"
        }
      }
    }
  },

  xl: {
    paddingTop: 19,
    paddingBottom: 19
  },
  lg: {
    // paddingTop: 15,
    // paddingBottom: 15
    lineHeight: "52.8px"
  },
  md: {
    paddingTop: 13,
    paddingBottom: 13
  },
  sm: {
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 15
  },
  xs: {
    paddingTop: 5.5,
    paddingBottom: 5.5,
    fontSize: 14
  },
  "@keyframes spin": {
    "to": {
      transform: "rotate(360deg)"
    }
  },
  spin: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:before": {
      content: '""',
      width: 16,
      height: 16,
      display: "inline-block",
      verticalAlign: "text-bottom",
      border: "3px solid currentColor",
      borderRightColor: "transparent",
      borderRadius: "50%",
      animation: "$spin .75s linear infinite",
      marginRight: 10
    }
  },
  headerButton: {
    minWidth: 220
  }
});
